<section class="section section-shaped">
  <div class="container">
    <div class="row mb-3">
      <div class="col-12">
        <div
          class="text-primary text-underline cursor-pointer back-button h5"
          (click)="investmentEddFormId ? redirect() : confirmCancel()"
        >
          {{ 'common.cancel' | translate }}
        </div>
      </div>
      <div class="col-12 text-center">
        <h2 class="font-weight-extrabold">{{ 'investment.requestForMoreInfo' | translate }}</h2>
      </div>
      <div class="col-12 text-justify mb-4">{{ 'investment.eddFormDescription' | translate }}</div>
    </div>
    @if (!isLoading) {
      <form (ngSubmit)="submit()" [formGroup]="form" [class.show-form-error]="showFormError">
        <div class="row">
          <div class="col-lg-12 input-panel">
            <div class="input-label">{{ 'investment.sourceOfWealth' | translate }}*</div>
            <mat-selection-list
              formControlName="sourceOfWealths"
              (selectionChange)="
                changeValidity(
                  form.value.sourceOfWealths.includes(othersId),
                  'othersSourceOfWealths'
                )
              "
            >
              @for (type of sourceOfWealths; track type) {
                <mat-list-option
                  class="list-option"
                  [value]="type.id"
                  checkboxPosition="before"
                  [disableRipple]="true"
                >
                  {{ type.name }}
                </mat-list-option>
              }
            </mat-selection-list>
            @if (form.value.sourceOfWealths.includes(othersId)) {
              <input
                [readonly]="investmentEddFormId"
                class="form-control mt-2 other-souce"
                formControlName="othersSourceOfWealths"
                type="text"
                placeholder="{{ 'common.pleaseSpecify' | translate }}"
              />
            }
            @if (showFormError && form.controls.sourceOfWealths.errors?.required) {
              <div class="text-danger">
                {{ 'common.pleaseSelect' | translate }}
              </div>
            }
          </div>
          <div class="col-lg-12 input-panel pb-0">
            <div class="input-label">{{ 'investment.sourceOfWealthDocument' | translate }}*</div>
          </div>
          <div class="col-lg-6 input-panel">
            @if (!investmentEddFormId) {
              @if (!isLoadingWealth) {
                <div class="input-field">
                  @if (!sourceOfWealthDoc) {
                    <div
                      class="document-upload cursor-pointer"
                      agmoUploader
                      [accept]="accept"
                      (selectFiles)="selectFile(1, $event)"
                    >
                      <div class="document-text text-left">
                        {{ 'signUp.uploadDocument' | translate }}
                      </div>
                      <div class="pitchin-icon pitchin-icon-upload"></div>
                    </div>
                  }
                  @if (sourceOfWealthDoc) {
                    <div class="document-upload uploaded">
                      <div class="document-text text-left">{{ sourceOfWealthDoc.name }}</div>
                      <div
                        class="pitchin-icon pitchin-icon-delete"
                        (click)="removeDocument(1)"
                      ></div>
                    </div>
                  }
                </div>
              }
              @if (isLoadingWealth) {
                <agmo-loading></agmo-loading>
              }
              @if (showFormError && !sourceOfWealthAttachmentInfo.attachmentInfo) {
                <div class="text-danger">
                  {{ 'common.pleaseUploadDocument' | translate }}
                </div>
              }
            }
            @if (investmentEddFormId && edd && edd.sourceOfWealthAttachmentUrl) {
              <div class="link" (click)="viewDocument(edd.sourceOfWealthAttachmentUrl)">
                {{ 'common.viewDocument' | translate }}
              </div>
            }
          </div>
          <div class="col-lg-12 input-panel">
            <div class="input-label">{{ 'investment.sourceOfFunds' | translate }}*</div>
            <mat-selection-list
              formControlName="sourceOfFunds"
              (selectionChange)="
                changeValidity(form.value.sourceOfFunds.includes(othersId), 'othersSourceOfFunds')
              "
            >
              @for (type of sourceOfFunds; track type) {
                <mat-list-option
                  class="list-option"
                  [value]="type.id"
                  checkboxPosition="before"
                  [disableRipple]="true"
                >
                  {{ type.name }}
                </mat-list-option>
              }
            </mat-selection-list>
            @if (form.value.sourceOfFunds.includes(othersId)) {
              <input
                [readonly]="investmentEddFormId"
                class="form-control mt-2 other-souce"
                formControlName="othersSourceOfFunds"
                type="text"
                placeholder="{{ 'common.pleaseSpecify' | translate }}"
                maxlength="255"
              />
            }
            @if (showFormError && form.controls.sourceOfFunds.errors?.required) {
              <div class="text-danger">
                {{ 'common.pleaseSelect' | translate }}
              </div>
            }
          </div>
          <div class="col-lg-12 input-panel pb-0">
            <div class="input-label">{{ 'investment.sourceOfFundsDocument' | translate }}*</div>
          </div>
          <div class="col-lg-6 input-panel">
            @if (!investmentEddFormId) {
              @if (!isLoadingFund) {
                <div class="input-field">
                  @if (!sourceOfFundsDoc) {
                    <div
                      class="document-upload cursor-pointer"
                      agmoUploader
                      [accept]="accept"
                      (selectFiles)="selectFile(2, $event)"
                    >
                      <div class="document-text text-left">
                        {{ 'signUp.uploadDocument' | translate }}
                      </div>
                      <div class="pitchin-icon pitchin-icon-upload"></div>
                    </div>
                  }
                  @if (sourceOfFundsDoc) {
                    <div class="document-upload uploaded">
                      <div class="document-text text-left">{{ sourceOfFundsDoc.name }}</div>
                      <div
                        class="pitchin-icon pitchin-icon-delete"
                        (click)="removeDocument(2)"
                      ></div>
                    </div>
                  }
                </div>
              }
              @if (isLoadingFund) {
                <agmo-loading></agmo-loading>
              }
              @if (showFormError && !sourceOfFundAttachmentInfo.attachmentInfo) {
                <div class="text-danger">
                  {{ 'common.pleaseUploadDocument' | translate }}
                </div>
              }
            }
            @if (investmentEddFormId && edd && edd.sourceOfFundAttachmentUrl) {
              <div class="link" (click)="viewDocument(edd.sourceOfFundAttachmentUrl)">
                {{ 'common.viewDocument' | translate }}
              </div>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 input-panel pb-0">
            <div class="input-label">{{ 'investment.relationshipToIssuer' | translate }}*</div>
          </div>
          <div class="col-lg-6 input-panel">
            <div class="input-field">
              <mat-select
                placeholder="{{ 'common.selectPlaceholder' | translate }}"
                class="form-control"
                formControlName="relationshipOfInvestorToTheIssuerType"
              >
                @for (relation of relationshipOfInvestorToTheIssuerType; track relation) {
                  <mat-option [value]="relation.id">
                    {{ relation.name }}
                  </mat-option>
                }
              </mat-select>
            </div>
          </div>
          <div class="col-lg-12 input-panel mb-3">
            <div class="input-label">{{ 'investment.thirdPartyQuestion' | translate }}*</div>
            <div class="input-field">
              <mat-radio-group
                formControlName="isThirdPartyAccount"
                [disabled]="investmentEddFormId"
                #isThirdPartyAccount
                (change)="updateDepositFormValidation(this.form.controls.isThirdPartyAccount.value)"
              >
                <mat-radio-button [value]="true">{{ 'common.yes' | translate }}</mat-radio-button>
                <mat-radio-button [value]="false">{{ 'common.no' | translate }}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
        @if (form.value.isThirdPartyAccount) {
          <h4 class="font-weight-bold text-danger mb-3">
            {{ 'investment.depositDetails' | translate }}
          </h4>
          <div class="text-justify mb-4">
            {{ 'investment.depositDetailsDescription' | translate }}
          </div>
          <div class="row">
            <div class="col-lg-12 input-panel pb-0">
              <div class="input-label">
                {{ 'investment.thirdPartyAccountOwnerName' | translate }}*
              </div>
            </div>
            <div class="col-lg-6 input-panel">
              <div class="input-field">
                <input
                  class="form-control"
                  formControlName="name"
                  type="text"
                  [readonly]="investmentEddFormId"
                  maxlength="100"
                />
              </div>
            </div>
            <div class="col-lg-12 input-panel pb-0">
              <div class="input-label">{{ 'profile.phoneNo' | translate }}*</div>
            </div>
            <div class="col-lg-6 input-panel">
              <div class="input-field phone-input-field">
                <mat-select class="form-control countryCode" formControlName="phoneCountryCode">
                  <mat-select-trigger>
                    {{ form.value.phoneCountryCode }}
                  </mat-select-trigger>
                  @for (country of countries; track country) {
                    <mat-option [value]="country.phonecode">
                      {{ country.name }} ({{ country.phonecode }})
                    </mat-option>
                  }
                </mat-select>
                <input
                  class="form-control"
                  formControlName="phoneNumber"
                  type="text"
                  digitOnly
                  [readonly]="investmentEddFormId"
                />
              </div>
              @if (
                form.controls.phoneNumber.errors &&
                form.controls.phoneNumber.errors.phoneInvalidFormat &&
                showFormError
              ) {
                <div class="error">
                  {{ 'common.incorrectPhoneNoFormat' | translate }}
                </div>
              }
            </div>
            <div class="col-lg-12 input-panel pb-0">
              <div class="input-label">{{ 'investment.nricpassportRegNo' | translate }}*</div>
            </div>
            <div class="col-lg-6 input-panel">
              <div class="input-field">
                <input
                  class="form-control"
                  formControlName="identityNo"
                  type="text"
                  [readonly]="investmentEddFormId"
                />
              </div>
            </div>
            <div class="col-lg-12 input-panel pb-0">
              <div class="input-label">{{ 'investment.correspondenceAddress' | translate }}*</div>
            </div>
            <div class="col-lg-6 input-panel">
              <div class="input-field">
                <input
                  class="form-control"
                  formControlName="address"
                  type="text"
                  [readonly]="investmentEddFormId"
                  maxlength="512"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 input-panel pb-0">
              <div class="input-label">
                {{ 'investment.natureRelationshipToThirdParty' | translate }}*
              </div>
            </div>
            <div class="col-lg-6 input-panel">
              <div class="input-field">
                <mat-select
                  placeholder="{{ 'common.selectPlaceholder' | translate }}"
                  class="form-control"
                  formControlName="eddNatureOfRelationshipWithThirdParty"
                  (selectionChange)="
                    changeValidity(
                      form.value.eddNatureOfRelationshipWithThirdParty == othersId,
                      'eddNatureOfRelationshipWithThirdPartyOthers'
                    )
                  "
                >
                  @for (relation of eddNatureOfRelationshipWithThirdParty; track relation) {
                    <mat-option [value]="relation.id">
                      {{ relation.name }}
                    </mat-option>
                  }
                </mat-select>
                @if (form.value.eddNatureOfRelationshipWithThirdParty == othersId) {
                  <input
                    class="form-control mt-2"
                    formControlName="eddNatureOfRelationshipWithThirdPartyOthers"
                    type="text"
                    placeholder="{{ 'common.pleaseSpecify' | translate }}"
                    maxlength="256"
                  />
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 input-panel pb-0">
              <div class="input-label">
                {{ 'investment.reasonUsingThirdPartyAccount' | translate }}*
              </div>
            </div>
            <div class="col-lg-6 input-panel">
              <div class="input-field">
                <mat-select
                  placeholder="{{ 'common.selectPlaceholder' | translate }}"
                  class="form-control"
                  formControlName="eddReasonForUsingThirdPartyAccount"
                  (selectionChange)="
                    changeValidity(
                      form.value.eddReasonForUsingThirdPartyAccount == othersId,
                      'eddReasonForUsingThirdPartyAccountOthers'
                    )
                  "
                >
                  @for (reason of eddReasonForUsingThirdPartyAccount; track reason) {
                    <mat-option [value]="reason.id">
                      {{ reason.name }}
                    </mat-option>
                  }
                </mat-select>
                @if (form.value.eddReasonForUsingThirdPartyAccount == othersId) {
                  <input
                    class="form-control mt-2"
                    formControlName="eddReasonForUsingThirdPartyAccountOthers"
                    type="text"
                    placeholder="{{ 'common.pleaseSpecify' | translate }}"
                    maxlength="1024"
                  />
                }
              </div>
            </div>
          </div>
        }
        <div class="row mt-5">
          @if (!investmentEddFormId) {
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-primary btn-submit">
                {{ 'common.submit' | translate }}
              </button>
            </div>
          }
          <div class="col-12">
            <div
              class="text-primary text-underline cursor-pointer back-button h5"
              (click)="investmentEddFormId ? redirect() : confirmCancel()"
            >
              {{ 'common.cancel' | translate }}
            </div>
          </div>
        </div>
      </form>
    }
    @if (isLoading) {
      <agmo-loading></agmo-loading>
    }
  </div>
</section>
